<script>
	import * as d3 from "d3";
	import {onMount} from "svelte";
	
    export let w = 400;
    export let h = 600;
    export let hash;
    export let stroke = true;
 
    
	let svg
  let svgElement
   

    export let colours = ['#000', '#CCC', '#DDD', '#333', '#999']
    let colour_prob = [0.2, 0.2, 0.2, 0.2, 0.2]  // probability of appearance of each colour

    // cumulative colour probabilities
    let colour_cum_prob = [];
    colour_prob.reduce(function(a,b,i) { return colour_cum_prob[i] = a+b; },0);

    let fractions = [1/5, 2/5, 3/5, 4/5, 1/2]  // hard coded split fractions
    let tol = 60;  // height/width tolerance on which to split
    let recurs = Math.floor(Math.random()*12)+2;  // level of recursion

    function update(){
      // initialise array of rectangles with a single, giant rectangle (..square)
      var rectangles = [{"x": 0, "y": 0, "width": w, "height": h}]

      // console.log("rect start", JSON.stringify(rectangles));

      var j = 0;  // recursion counter
      while(j < recurs){
        j++;

        var n = rectangles.length;  // number of initial rectangles in this loop
        var to_remove = [];  // array of indices of rectangles to remove

        // loop through existing rectangles
        for(var i=0; i<n; i++){

          // test if rectangle already small
          if(rectangles[i]['width'] > tol && rectangles[i]['height'] > tol){

            to_remove.push(i);  // save for removal later

            // calculate split fraction
            var frac = fractions[Math.floor(Math.random() * fractions.length)];
            var x = rectangles[i]['x'];
            var y = rectangles[i]['y'];

            // decide whether to cut vertically or horizontally
            if(Math.random() > 0.5) {
              var width = rectangles[i]['width'] * frac;
              var height = rectangles[i]['height'];
              rectangles.push({"x": x + width, "y": y, "width": rectangles[i]['width'] - width, height});
            }
            else {
              var width = rectangles[i]['width'];
              var height = rectangles[i]['height'] * frac;
              rectangles.push({"x": x, "y": y + height, "width": width, "height": rectangles[i]['height'] - height});
            }

            rectangles.push({"x": x, "y": y, "width": width, "height": height});
          }
        }

        // remove old rectangles (loop in reverse order to avoid messing up indexing)
        for(var i=to_remove.length-1; i>=0; i--){
            rectangles.splice(to_remove[i], 1);
        }
      }

      for(i=0; i < rectangles.length; i++){

        var condition = Math.random()
        var colourIndex = colour_cum_prob.findIndex( function(elem) {return elem > condition} );

        svg.append("rect")
           .attr("x", rectangles[i]['x'] )
           .attr("y", rectangles[i]['y'] )
           .attr("width", rectangles[i]['width'] )
           .attr("height", rectangles[i]['height'] )
           .attr("fill", "black")
           .attr("opacity", randomNumber())
           .attr("stroke-width", stroke ? 8 : 0)
           .attr("stroke", "white");


      }

      svg.append("rect")
        .attr("x",0)
        .attr("y", 0)
        .attr("width", w)
        .attr("height",h)
        .attr("stroke", "white")
        .attr("stroke-width", stroke ? 32 : 0 );

    }


    function randomNumber() {
		return (Math.random()+.2);
	}
    
onMount(()=>{
	
	 svg= d3.select(svgElement)
      .append("svg")
    
	
	update();
  

})



</script>

<svg class="mondrianbg-{hash}" viewbox="0 0 {w} {h}" bind:this={svgElement} />




